import { defineStore } from 'pinia';
import axios from 'axios';
import type { Scripts } from '@/types';

export const useScriptsStore = defineStore('scripts', () => {
    function toSetScripts(scripts: Scripts[]): void {
        scripts.forEach((script) => {
            // Function to create and set attributes on elements
            const createElementWithAttributes = (element: HTMLElement, code: string) => {
                const attributeMatches = code.match(/([\w-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|[^>\s]*))?/g);
                if (attributeMatches) {
                    attributeMatches.forEach((attribute) => {
                        if (attribute !== element.tagName.toLowerCase()) {
                            // Avoid setting tag name as attribute
                            const match = attribute.match(/([\w-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|[^>\s]*))?/);
                            if (match) {
                                const attrName = match[1];
                                const attrValue = match[2] || match[3] || '';
                                element.setAttribute(attrName, attrValue);
                            }
                        }
                    });
                }
            };

            if (script.type === 'meta') {
                const metaTag = document.createElement('meta');
                createElementWithAttributes(metaTag, script.code);
                (script.locale === 'head' ? document.head : document.body).appendChild(metaTag);
            }

            if (script.type === 'script') {
                const scriptJS = document.createElement('script');
                createElementWithAttributes(scriptJS, script.code);
                const contentMatch = script.code.match(/<script(?:[^>]*)>([\s\S]*?)<\/script>/);
                if (contentMatch && contentMatch[1]) {
                    const scriptContent = contentMatch[1].trim();
                    scriptJS.textContent = scriptContent;
                }
                (script.locale === 'head' ? document.head : document.body).appendChild(scriptJS);
            }

            if (script.type === 'link') {
                const link = document.createElement('link');
                createElementWithAttributes(link, script.code);
                (script.locale === 'head' ? document.head : document.body).appendChild(link);
            }
        });
    }

    const awaitGetScripts = async () => {
        try {
            const response = await axios.get<Scripts[]>('/main-api/seo-settings/');
            if (response.status === 200) {
                toSetScripts(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return { awaitGetScripts };
});
